export const toActivatableBool = (value) =>
  value === true ||
  value === 1 ||
  value === "1" ||
  String(value).toLowerCase() === "true";

export const pickDuration = (...values) => {
  const match = values.find((value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0;
  });

  return match ? Number(match) : null;
};

const HEADER_DURATION_ACTIVATABLE_KEYS = [
  "reservation_header_duration",
  "show_reservation_header_duration",
  "tour_header_duration",
  "show_tour_duration_in_header",
];

export const isHeaderDurationEnabled = (optionalFields) =>
  HEADER_DURATION_ACTIVATABLE_KEYS.some((key) =>
    toActivatableBool(optionalFields?.[key])
  );
